//Reset data
export const RESET = "INSTITUTIONTYPE_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "INSTITUTIONTYPE_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INSTITUTIONTYPE_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INSTITUTIONTYPE_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INSTITUTIONTYPE_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "INSTITUTIONTYPE_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INSTITUTIONTYPE_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INSTITUTIONTYPE_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INSTITUTIONTYPE_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INSTITUTIONTYPE_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "INSTITUTIONTYPE_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "INSTITUTIONTYPE_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INSTITUTIONTYPE_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INSTITUTIONTYPE_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INSTITUTIONTYPE_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "INSTITUTIONTYPE_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "INSTITUTIONTYPE_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INSTITUTIONTYPE_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INSTITUTIONTYPE_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INSTITUTIONTYPE_LIST_SET_MODAL_TYPE"